import { useCallback, useEffect, useState } from 'react';

import { hrApi } from '@/api';

import { EmployeeSelect, TrainingCourseSelect } from '@/components/selects';

import { PageHeader } from '@/components/layout/PageHeader';

import { Button } from '@/components/ui/Button';

import { Input } from '@/components/ui/Input';

import { DataTable, type Column } from '@/components/ui/DataTable';

import { dataTablePageProps, paginateClientList, usePagination } from '@/hooks/usePagination';

import type { HrTrainingCourse } from '@/types/hr';

import { showApiError } from '@/utils/apiError';

import { notify } from '@/core/toast/notify';



export function HrTrainingPage() {

  const pagination = usePagination();

  const [data, setData] = useState<HrTrainingCourse[]>([]);

  const [loading, setLoading] = useState(false);

  const [title, setTitle] = useState('');

  const [employeeId, setEmployeeId] = useState('');

  const [courseId, setCourseId] = useState('');



  const load = useCallback(async () => {

    setLoading(true);

    try {

      const rows = await hrApi.listTrainingCourses();

      setData(rows);

      pagination.applyClientCount(rows.length);

    } catch (err) {

      showApiError(err, 'Failed to load training courses');

    } finally {

      setLoading(false);

    }

  }, []);



  useEffect(() => {

    load();

  }, [load]);



  const createCourse = async () => {

    try {

      await hrApi.createTrainingCourse({ title, category: 'COMPLIANCE' });

      notify.success('Course created');

      setTitle('');

      load();

    } catch (err) {

      showApiError(err, 'Create course failed');

    }

  };



  const assign = async () => {

    try {

      await hrApi.assignTraining({ employeeId: Number(employeeId), courseId: Number(courseId) });

      notify.success('Training assigned');

    } catch (err) {

      showApiError(err, 'Assign failed');

    }

  };



  const columns: Column<HrTrainingCourse>[] = [

    { key: 'id', header: '#' },

    { key: 'title', header: 'Title' },

    { key: 'category', header: 'Category' },

    { key: 'provider', header: 'Provider' },

    { key: 'active', header: 'Active', render: (row) => (row.active ? 'Yes' : 'No') },

  ];



  return (

    <div>

      <PageHeader title="Training" description="Courses, assignments, and completion tracking" breadcrumbs={[{ label: 'Org', to: '/org' }, { label: 'HR', to: '/hr' }, { label: 'Training' }]} />

      <div className="mb-4 grid gap-3 md:grid-cols-2">

        <section className="card space-y-2 p-4">

          <h3 className="font-semibold">Create course</h3>

          <Input label="Title" value={title} onChange={(e) => setTitle(e.target.value)} />

          <Button onClick={() => void createCourse()}>Create</Button>

        </section>

        <section className="card space-y-2 p-4">

          <h3 className="font-semibold">Assign training</h3>

          <EmployeeSelect value={employeeId} onChange={setEmployeeId} hrScoped />

          <TrainingCourseSelect value={courseId} onChange={setCourseId} />

          <Button onClick={() => void assign()}>Assign</Button>

        </section>

      </div>

      <DataTable

        columns={columns}

        data={paginateClientList(data, pagination.page, pagination.size)}

        loading={loading}

        keyField="id"

        {...dataTablePageProps(pagination)}

      />

    </div>

  );

}


